/**
 * Commission Rates by Broker
 * 
 * Structure: { broker: { dataProvider: { symbol: ratePerSide } } }
 * Rates are PER SIDE and include all fees (Exchange, NFA, Order Routing, Commission)
 * 
 * To calculate round-trip: rate × 2 × quantity
 * 
 * Last Updated: February 2026
 */

export const COMMISSION_RATES = {
  // ===========================================
  // BULENOX
  // ===========================================
  'Bulenox': {
    'default': {
      // Micro Equity Index
      'MNQ': 0.61, 'MES': 0.61, 'M2K': 0.61, 'MYM': 0.61,
      // Standard Equity Index  
      'NQ': 2.09, 'ES': 2.09, 'RTY': 2.09, 'YM': 2.09,
      // Micro Energy
      'MCL': 0.76, 'MHO': 0.77, 'MRB': 0.77,
      // Standard Energy
      'CL': 2.26, 'HO': 2.27, 'RB': 2.27, 'NG': 2.27,
      // Micro Metals
      'MGC': 0.67, 'SIL': 0.82,
      // Standard Metals
      'GC': 2.31, 'SI': 2.32, 'HG': 2.32, 'PL': 2.32,
      // Micro FX
      'M6E': 0.52, 'M6A': 0.52, 'M6B': 0.52, 'MJY': 0.52, 'MSF': 0.52, 'MCD': 0.52,
      // Standard FX
      '6E': 2.02, '6A': 2.02, '6B': 2.02, '6J': 2.02, '6S': 2.02, '6C': 2.02, '6N': 2.02, '6M': 2.02,
      // Crypto
      'MBT': 2.57, 'MET': 0.57, 'BTC': 5.07,
      // Agricultures
      'ZC': 2.27, 'ZS': 2.27, 'ZW': 2.27, 'ZM': 2.27, 'ZL': 2.27,
      // Interest Rates
      'ZN': 2.02, 'ZB': 2.02, 'ZF': 2.02, 'ZT': 2.02, 'ZQ': 2.02,
      // Micro Treasury
      '2YY': 0.52, '10Y': 0.52, '30Y': 0.52,
    }
  },
  
  // ===========================================
  // APEX TRADER FUNDING
  // ===========================================
  'Apex': {
    'Rithmic': {
      // Micro Equity Index
      'MES': 0.51, 'MNQ': 0.51, 'MYM': 0.51, 'M2K': 0.51,
      // Standard Equity Index
      'ES': 1.99, 'NQ': 1.99, 'YM': 1.99, 'RTY': 1.99, 'EMD': 1.99, 'NKD': 1.99,
      // Interest Rates
      'ZT': 1.36, 'ZF': 1.41, 'ZN': 1.51, 'ZB': 1.72, 'UB': 1.56,
      // Currency - Standard
      '6A': 2.36, '6B': 2.36, '6C': 2.36, '6E': 2.36, '6J': 2.36, '6N': 2.36,
      // Currency - Micro
      'M6A': 0.42, 'M6E': 0.42, 'M6J': 0.42,
      // Energy
      'CL': 1.98, 'QM': 1.96, 'MCL': 0.51, 'NG': 1.98, 'QG': 1.26, 'HO': 1.98, 'RB': 1.98,
      // Metals
      'GC': 2.31, 'SI': 2.31, 'HG': 2.31, 'PL': 2.31, 'PA': 2.31,
      'QI': 1.51, 'QO': 1.51, 'MGC': 0.76,
      // Agriculture
      'ZC': 2.79, 'ZW': 2.79, 'ZS': 2.79, 'ZM': 2.79, 'ZL': 2.79,
      'HE': 2.79, 'LE': 2.79, 'GF': 2.79,
      // Crypto
      'MBT': 2.76, 'MET': 0.46,
    },
    'Tradovate': {
      // Micro Equity Index
      'MES': 0.52, 'MNQ': 0.52, 'MYM': 0.52, 'M2K': 0.52,
      // Standard Equity Index
      'ES': 1.55, 'NQ': 1.55, 'YM': 1.55, 'RTY': 1.55, 'EMD': 1.50, 'NKD': 2.32,
      // Interest Rates
      'ZT': 0.82, 'ZF': 0.82, 'ZN': 0.97, 'ZB': 1.04, 'UB': 1.12, '10Y': 0.47,
      // Currency - Standard
      '6A': 1.77, '6B': 1.77, '6C': 1.77, '6E': 1.77, '6J': 1.77, '6N': 1.77, '6M': 1.77, '6S': 1.77,
      'E7': 1.02, 'J7': 1.02,
      // Currency - Micro
      'M6A': 0.41, 'M6E': 0.41, 'M6J': 0.41, 'M6B': 0.41, 'MISF': 0.41, 'MCD': 0.41,
      // Energy
      'CL': 1.67, 'QM': 1.37, 'MCL': 0.67, 'NG': 1.77, 'QG': 0.67, 'HO': 1.67, 'RB': 1.67,
      // Metals
      'GC': 1.77, 'SI': 1.77, 'HG': 1.77, 'PL': 1.77, 'PA': 1.77,
      'QI': 1.17, 'QO': 1.17, 'MGC': 0.67,
      // Agriculture
      'ZC': 2.27, 'ZW': 2.27, 'ZS': 2.27, 'ZM': 2.27, 'ZL': 2.27, 'ZR': 2.27, 'ZO': 2.27,
      'HE': 2.27, 'LE': 2.27, 'GF': 2.27, 'LB': 2.27,
      'XW': 1.20, 'XC': 1.20, 'XK': 1.20,
      // Crypto
      'MBT': 2.67, 'MET': 0.37,
      // Eurex (requires additional subscription)
      'FDAX': 1.46, 'FDXM': 0.46, 'FESX': 0.59, 'FVS': 0.68, 'FXXP': 0.39, 'FDXS': 0.34, 'FSXE': 0.30,
      'FGBX': 0.45, 'FGBS': 0.45, 'FGBM': 0.45, 'FGBL': 0.45,
    },
    'default': 'Rithmic' // Default data provider for Apex
  },
  
  // ===========================================
  // MY FUNDED FUTURES (CQG - commissions included in NinjaTrader export)
  // ===========================================
  'My Funded Futures': {
    'CQG': {
      // Micro Equity Index (RT costs from help.myfundedfutures.com)
      'MNQ': 0.95, 'MES': 0.95, 'M2K': 0.95, 'MYM': 0.95,
      // Standard Equity Index
      'NQ': 2.34, 'ES': 2.34, 'RTY': 2.34, 'YM': 2.88,
      // Micro Energy
      'MCL': 0.58,
      // Standard Energy
      'CL': 2.46, 'HO': 2.46, 'RB': 3.00, 'NG': 2.56, 'QM': 2.16, 'QG': 1.46,
      // Micro Metals
      'MGC': 1.10, 'SIL': 1.42,
      // Standard Metals
      'GC': 2.56, 'SI': 2.56, 'HG': 2.56, 'PL': 2.06,
      // Micro FX
      'M6E': 0.72, 'M6A': 0.72,
      // Standard FX
      '6E': 2.56, '6A': 2.52, '6B': 2.56, '6C': 2.56, '6J': 2.56, '6S': 2.56, '6N': 2.56,
      // Crypto
      'MBT': 1.75, 'MET': 0.58,
      // Agricultures
      'ZC': 3.06, 'ZS': 3.06, 'ZW': 3.06, 'ZM': 3.06, 'ZL': 3.06,
      // Livestock
      'HE': 3.06, 'LE': 3.06,
      // Interest Rates (from instrument list)
      'NKD': 3.11,
    },
    'default': 'CQG',
    'commissionsInExport': true  // CQG includes commissions in NinjaTrader export
  },

  // ===========================================
  // TAKE PROFIT TRADER (CQG - commissions included in NinjaTrader export)
  // ===========================================
  'Take Profit Trader': {
    'CQG': {
      // Test/PRO accounts: $0.50 RT for micros, $5.00 RT for standard
      // Micro Equity Index
      'MNQ': 0.25, 'MES': 0.25, 'M2K': 0.25, 'MYM': 0.25,
      // Standard Equity Index
      'NQ': 2.50, 'ES': 2.50, 'RTY': 2.50, 'YM': 2.50,
      // Micro Energy
      'MCL': 0.25,
      // Standard Energy
      'CL': 2.50, 'HO': 2.50, 'RB': 2.50, 'NG': 2.50,
      // Micro Metals
      'MGC': 0.25, 'SIL': 0.25,
      // Standard Metals
      'GC': 2.50, 'SI': 2.50, 'HG': 2.50, 'PL': 2.50,
      // Micro FX
      'M6E': 0.25, 'M6A': 0.25, 'M6B': 0.25,
      // Standard FX
      '6E': 2.50, '6A': 2.50, '6B': 2.50, '6C': 2.50, '6J': 2.50, '6S': 2.50, '6N': 2.50,
      // Crypto
      'MBT': 2.50, 'MET': 0.25,
      // Agricultures
      'ZC': 2.50, 'ZS': 2.50, 'ZW': 2.50, 'ZM': 2.50, 'ZL': 2.50,
    },
    'default': 'CQG',
    'commissionsInExport': true  // CQG includes commissions in NinjaTrader export
  },

  // ===========================================
  // TRADEIFY (Tradovate - commissions included in NinjaTrader export)
  // ===========================================
  'Tradeify': {
    'Tradovate': {
      // Based on help.tradeify.co commission fees (all-in rates)
      // Micro Equity Index (~$1.82 RT)
      'MNQ': 0.91, 'MES': 0.91, 'M2K': 0.91, 'MYM': 0.91,
      // Standard Equity Index (~$5.76 RT)
      'NQ': 2.88, 'ES': 2.88, 'RTY': 2.88, 'YM': 2.88,
      // Micro Energy
      'MCL': 0.91,
      // Standard Energy
      'CL': 2.88, 'HO': 2.88, 'RB': 2.88, 'NG': 2.88,
      // Micro Metals
      'MGC': 0.91, 'SIL': 0.91,
      // Standard Metals
      'GC': 2.88, 'SI': 2.88, 'HG': 2.88, 'PL': 2.88,
      // Micro FX
      'M6E': 0.91, 'M6A': 0.91, 'M6B': 0.91,
      // Standard FX
      '6E': 2.88, '6A': 2.88, '6B': 2.88, '6C': 2.88, '6J': 2.88, '6S': 2.88, '6N': 2.88,
      // Crypto (MBT is higher ~$4/RT)
      'MBT': 2.00, 'MET': 0.38,
      // Agricultures
      'ZC': 2.88, 'ZS': 2.88, 'ZW': 2.88, 'ZM': 2.88, 'ZL': 2.88,
    },
    'default': 'Tradovate',
    'commissionsInExport': true  // Tradovate includes commissions in NinjaTrader export
  },

  // ===========================================
  // TOPSTEP (placeholder - needs real rates)
  // ===========================================
  // 'Topstep': {
  //   'Rithmic': { ... },
  //   'Tradovate': { ... },
  //   'default': 'Rithmic'
  // },
  
  // ===========================================
  // EARN2TRADE (placeholder - needs real rates)
  // ===========================================
  // 'Earn2Trade': {
  //   'Rithmic': { ... },
  //   'default': 'Rithmic'
  // },
};

/**
 * Get commission rate for a specific symbol
 * @param {string} broker - Broker name (e.g., 'Bulenox', 'Apex')
 * @param {string} symbol - Trading symbol (e.g., 'MNQ', 'ES')
 * @param {string} dataProvider - Data provider (e.g., 'Rithmic', 'Tradovate') - optional
 * @returns {number|null} - Commission rate per side, or null if not found
 */
export const getCommissionRate = (broker, symbol, dataProvider = null) => {
  if (!broker || !symbol) return null;
  
  const brokerRates = COMMISSION_RATES[broker];
  if (!brokerRates) return null;
  
  // Determine which rate table to use
  let rateTable;
  if (dataProvider && brokerRates[dataProvider]) {
    rateTable = brokerRates[dataProvider];
  } else if (brokerRates.default && typeof brokerRates.default === 'string') {
    // Default is a provider name (like 'Rithmic')
    rateTable = brokerRates[brokerRates.default];
  } else if (brokerRates.default && typeof brokerRates.default === 'object') {
    // Default is the rate table itself
    rateTable = brokerRates.default;
  }
  
  if (!rateTable) return null;
  
  const upperSymbol = symbol.toUpperCase();
  return rateTable[upperSymbol] || null;
};

/**
 * Calculate total commission for a trade
 * @param {string} broker - Broker name
 * @param {string} symbol - Trading symbol
 * @param {number} quantity - Number of contracts
 * @param {string} dataProvider - Data provider (optional)
 * @param {number} fallbackRate - Rate to use if symbol not found (optional)
 * @returns {number} - Total round-trip commission
 */
export const calculateCommission = (broker, symbol, quantity, dataProvider = null, fallbackRate = 0) => {
  const rate = getCommissionRate(broker, symbol, dataProvider);
  const effectiveRate = rate !== null ? rate : fallbackRate;
  return quantity * 2 * effectiveRate;
};

/**
 * Get list of brokers that have commission rate tables
 * @returns {string[]} - Array of broker names
 */
export const getSupportedBrokers = () => {
  return Object.keys(COMMISSION_RATES);
};

/**
 * Get available data providers for a broker
 * @param {string} broker - Broker name
 * @returns {string[]} - Array of data provider names
 */
export const getDataProviders = (broker) => {
  const brokerRates = COMMISSION_RATES[broker];
  if (!brokerRates) return [];
  
  return Object.keys(brokerRates).filter(key => key !== 'default' && typeof brokerRates[key] === 'object');
};

/**
 * Check if a broker has multiple data providers
 * @param {string} broker - Broker name
 * @returns {boolean}
 */
export const hasMultipleDataProviders = (broker) => {
  return getDataProviders(broker).length > 1;
};

/**
 * Check if a broker reports commissions in the NinjaTrader export
 * (CQG and Tradovate-based brokers typically include commissions)
 * @param {string} broker - Broker name
 * @returns {boolean}
 */
export const brokerReportsCommissions = (broker) => {
  const brokerRates = COMMISSION_RATES[broker];
  return brokerRates?.commissionsInExport === true;
};

/**
 * Calculate commission for a trade, considering if broker reports commissions in export
 * @param {string} broker - Broker name
 * @param {string} symbol - Trading symbol
 * @param {number} quantity - Number of contracts
 * @param {number} importedCommission - Commission value from CSV import (per contract or total)
 * @param {string} dataProvider - Data provider (optional)
 * @param {number} fallbackRate - Rate to use if symbol not found (optional)
 * @returns {number} - Total round-trip commission
 */
export const calculateSmartCommission = (broker, symbol, quantity, importedCommission = 0, dataProvider = null, fallbackRate = 0) => {
  // If broker reports commissions in export AND import has a commission value, use the import value
  if (brokerReportsCommissions(broker) && importedCommission > 0) {
    // Assume importedCommission is already the total commission for the trade
    return importedCommission;
  }
  
  // Otherwise, calculate from our rate tables
  return calculateCommission(broker, symbol, quantity, dataProvider, fallbackRate);
};

/**
 * Calculate commission for a trade object using account details
 * This is the CANONICAL function that should be used everywhere for trade commission
 * @param {object} trade - Trade object with symbol, quantity, importedCommission
 * @param {object} account - Account object with broker, dataProvider, commissionPerSide
 * @returns {number} - Total round-trip commission for this trade
 */
export const getTradeCommission = (trade, account) => {
  if (!trade || !account) return 0;
  
  const quantity = parseInt(trade.quantity) || 0;
  if (quantity === 0) return 0;
  
  const broker = account.broker;
  const dataProvider = account.dataProvider;
  const symbol = trade.symbol?.toUpperCase();
  const importedCommission = trade.importedCommission || 0;
  const fallbackRate = account.commissionPerSide || 0;
  
  return calculateSmartCommission(broker, symbol, quantity, importedCommission, dataProvider, fallbackRate);
};

/**
 * Calculate Net P&L for a trade (Gross P&L minus commission)
 * This is the CANONICAL function that should be used everywhere for Net P&L
 * @param {object} trade - Trade object with pnl, symbol, quantity, importedCommission
 * @param {object} account - Account object with broker, dataProvider, commissionPerSide
 * @returns {{ grossPnl: number, commission: number, netPnl: number }}
 */
export const getTradeNetPnL = (trade, account) => {
  const grossPnl = parseFloat(trade?.pnl) || 0;
  const commission = getTradeCommission(trade, account);
  const netPnl = grossPnl - commission;
  
  return { grossPnl, commission, netPnl };
};

export default COMMISSION_RATES;
